import React from 'react';
import { Globe02Icon } from '@milanote/roma-icons';
import { useSelector } from 'react-redux';

import { Select } from '@milanote/roma';
import { selectIsMobileAppMode } from '../../platform/platformSelector';
import { type LocaleOption } from '../../user/account/accountModal/localisation/localizationConstants';

type AuthLocaleSelectProps = {
    selectedLocale: string | null;
    localeOptions: LocaleOption[];
    onSelectLocale: (locale: string | null) => void;
    className?: string;
};

const AuthLocaleSelect: React.FC<AuthLocaleSelectProps> = ({
    selectedLocale,
    localeOptions,
    onSelectLocale,
    className,
}) => {
    const isMobile = useSelector(selectIsMobileAppMode);
    const selectSize = isMobile ? 'md' : 'sm';

    if (!selectedLocale || !localeOptions.length) return null;

    const items = localeOptions.map(({ id, label }) => ({
        id,
        label,
    }));

    return (
        <div className={className || 'flex justify-center'}>
            <Select
                value={selectedLocale}
                onChange={(key) => onSelectLocale(key != null ? String(key) : null)}
                items={items}
                size={selectSize}
                leadingIcon={Globe02Icon}
                className="w-[142px]"
                native={isMobile}
            >
                {(item) => <Select.Item {...item} />}
            </Select>
        </div>
    );
};

export default AuthLocaleSelect;
